module.exports = __webpack_public_path__ + "img/logo-1.41ec85ef.png";